import {
	SideNavigationDashboardIcon,
	SideNavigationCustomerServiceIcon,
	SideNavigationTransactionsIcon,
	SideNavigationLoanManagementIcon,
	// SideNavigationFTDManagementIcon,
	SideNavigationAccountingIcon,
	SideNavigationTellerManagementIcon,
	SideNavigationReportIcon,
	SideNavigationApprovalIcon,
	SideNavigationUserManagementIcon,
	SideNavigationConfigurationIcon,
	// SideNavigationSignOutIcon
} from "../assets";

export const sideNavigationItems = [
	{
		name: "Dashboard",
		icon: <SideNavigationDashboardIcon />,
		url: "/dashboard",
	},
	{
		name: "Customer Service",
		icon: <SideNavigationCustomerServiceIcon />,
		subItems: [
			{
				name: "Customer List",
				url: "/customerservice/customerlist",
			},
			{
				name: "Group List",
				url: "/customerservice/grouplist",
			},
			{
				name: "Print Statement",
				url: "/customerservice/printstatement",
			},
		],
	},
	{
		name: "Transactions",
		icon: <SideNavigationTransactionsIcon />,
		subItems: [
			{
				name: "Transaction Posting",
				url: "/transaction/posting",
			},
			{
				name: "Funds Transfer",
				url: "/transaction/fundstransfer",
			},
			// {
			// 	name: "Manual Charge Posting",
			// 	url: "/transaction/manualchargeposting",
			// },
		],
	},
	{
		name: "Loan Management",
		icon: <SideNavigationLoanManagementIcon />,
		subItems: [
			{
				name: "Book Loan",
				url: "/loanmanagement/application",
			},
		],
	},
	// {
	// 	name: "FTD Management",
	// 	icon: <SideNavigationFTDManagementIcon />,
	// 	subItems: [
	// 		{
	// 			name: "",
	// 			url: "",
	// 		},
	// 	],
	// },
	{
		name: "Accounting",
		icon: <SideNavigationAccountingIcon />,
		subItems: [
			{
				name: "Chart of Account",
				url: "/accounting/chartofaccount",
			},
			{
				name: "Journal Entry",
				url: "/accounting/journalentry",
			},
			{
				name: "Transaction Reversal",
				url: "/accounting/transactionreversal",
			},
		],
	},
	{
		name: "Teller Management",
		icon: <SideNavigationTellerManagementIcon />,
		subItems: [
			{
				name: "Teller Transaction",
				url: "/tellermanagement/vault",
			},
		],
	},
	{
		name: "Report",
		icon: <SideNavigationReportIcon />,
		subItems: [
			{
				name: "Audit Trail",
				url: "/report/audittrail",
			},
			{
				name: "Disbursed Loan Report",
				url: "/report/disbursedloan",
			},
			{
				name: "GL Transactions Report",
				url: "/report/gltransactions",
			},
			{
				name: "Customer Report",
				url: "/report/customer",
			},
			{
				name: "Group Report",
				url: "/report/group",
			},
			{
				name: "Outstanding Loan Balance Report",
				url: "/report/outstandingloanbalance",
			},
			{
				name: "Loan Portfolio Report",
				url: "/report/loanportfolio",
			},
			{
				name: "Income Statement Report",
				url: "/report/incomestatement",
			},
		],
	},
	{
		name: "Approval",
		icon: <SideNavigationApprovalIcon />,
		subItems: [
			{
				name: "Customer Approval",
				url: "/approval/customer",
			},
			{
				name: "Teller Posting Approval",
				url: "/approval/tellerposting",
			},
			{
				name: "Pending Loan Approval",
				url: "/approval/pendingloan",
			},
			{
				name: "Manual Charge Posting Approval",
				url: "/approval/manualchargeposting",
			},
		],
	},
	{
		name: "User Management",
		icon: <SideNavigationUserManagementIcon />,
		subItems: [
			{
				name: "MFI User",
				url: "/usermanagement/mfiuser",
			},
			{
				name: "Assign Teller",
				url: "/usermanagement/teller",
			},
			{
				name: "User Role",
				url: "/usermanagement/role",
			},
			{
				name: "Access Control",
				url: "/usermanagement/accesscontrol",
			},
		],
	},
	{
		name: "Configuration",
		icon: <SideNavigationConfigurationIcon />,
		subItems: [
			{
				name: "Branch",
				url: "/configuration/branch",
			},
			{
				name: "Savings Product",
				url: "/configuration/savingsproduct",
			},
			{
				name: "Currency Exchange Rate",
				url: "/configuration/currencyexchangerate",
			},
			{
				name: "Payment Method",
				url: "/configuration/paymentmethod",
			},
			{
				name: "GL Balance Posting",
				url: "/configuration/glbalanceposting",
			},
			{
				name: "System Charge",
				url: "/configuration/systemcharge",
			},
			{
				name: "Loan Products",
				url: "/configuration/loanproducts",
			},
			{
				name: "GL Group Management",
				url: "/configuration/glgroupmanagement",
			},
			{
				name: "Tier Management",
				url: "/configuration/tiermanagement",
			},
			{
				name: "System Settings",
				url: "/configuration/systemsettings",
			},
		],
	},
];
